import React from 'react';

import './styles.less';

export default props => {
  return (
    <div className="upload-progress-loading-panel">
      <div className="upload-progress-check" />
      <div className="upload-progress-container">
        <div
          className="upload-progress-bar"
          style={{ transform: `translateX(${-100 + props.progress}%)` }}
        />
      </div>
    </div>
  );
};
